import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, DatePicker, Menu, Dropdown, Badge } from 'antd'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'

import { useListData, usePet, useToggle, getGradient, server } from '../../modules'

import { addOrderItem, clearOrder, modifyOrderItem, removeOrderItem } from '../../store/actions'

import Order from './order'
import OrderVariants from '../modals/ordervariants'
import Variants from '../drawers/variants'
import Receive from '../resusable/receive'

const { RangePicker } = DatePicker

export const SaleItem = ({ item, order, selectItem, i }) => {
    let { name, variants } = item

    const [onComplete, setOnComplete] = useState()
    const [quantity, setQty] = useState(0)

    const { closeSnackbar } = useSnackbar()

    const dispatch = useDispatch()

    const [, canDispense] = usePet('canDispense', {
        id: item._id,
        quantity,
        targets: localStorage
    }, {
        notify: true, callback: ({ data }, notif, ops) => {
            closeSnackbar()
            if (data.status) {
                onComplete?.callback()
            } else {
                if (item.type === 'Sale Item') {
                    notif(`${data.store} only has ${data.qty} of ${data.item} left`, ops('warning'))
                } else {
                    notif(`${data.store} only has ${data.ingredients[Object.keys(data.ingredients)[0]]} of ${Object.keys(data.ingredients)[0]} left`, ops('warning'))
                }
            }
        }, manual: true, load: { msg: 'Checking inventory...' }
    })

    let variantSelected = variants?.length > 0 ? variants.some(variant => order.findIndex(itm => itm.variant._id === variant._id) >= 0) : false

    const okToDispense = (quantity, callback) => {
        setQty(quantity)
        setOnComplete({ callback })
        canDispense()
    }

    let index = order.findIndex(itm => itm.variant._id === item._id)
    const addItem = itm => {
        if (index >= 0) {
            okToDispense(order[index].qty + 1, () => dispatch(modifyOrderItem(index, order[index].qty + 1)))
        } else {
            okToDispense(1, () => dispatch(addOrderItem(itm, itm)))
        }
    }

    const modifyQty = val => {
        if (val > 0) {
            okToDispense(val, () => dispatch(modifyOrderItem(index, val)))
        } else if (val === 0) {
            dispatch(removeOrderItem(index))
        }
    }

    return (
        <div className={`pt-4 bg-white w-full md:w-56 justify-center items-center px-6 py-4 flex flex-col rounded-lg shadow-md ${variantSelected || (index >= 0) ? 'order-item-selected' : ''} hover:scale-105 transition transform duration-500 cursor-pointer`}>
            <span onClick={() => variants?.length > 0 ? selectItem(item) : addItem(item)} className="absolute w-full h-full z-0" />
            {
                item?.image ? <img src={ `${server}/uploads/sale_items/${item.image}`} className="rounded-full h-40 w-40 object-cover" />
                : <div onClick={() => variants?.length > 0 ? selectItem(item) : addItem(item)} className={`rounded-full bg-cover h-40 w-40 object-cover ${getGradient(i)}`} />
            }
            <h4 className="mt-8 border-b-2">{name}{ item?.ref?.code ? ` (${item?.ref?.code})` : '' }</h4>
            <div className="mb-3 text-center capitalize">{variants?.length > 0 ? `${variants.length} types` : `Ksh. ${item.price}${ item?.maxDiscount > 0 ? ` (Min: ${item.price - item?.maxDiscount})` : '' }` }</div>
            {
                index >= 0 &&
                <div className="z-10 p-2 text-left flex justify-center items-center">
                    <button onClick={() => modifyQty(order[index].qty - 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                    <div className="p-3">{order[index].qty}</div>
                    <button onClick={() => modifyQty(order[index].qty + 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
                </div>
            }
        </div>
    )
}

const NewBill = ({ onComplete }) => {
    const [item, setItem] = useState(null)
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState(null)
    const [string, setString] = useState('')

    const { id } = useParams()

    const dispatch = useDispatch()

    const history = useHistory()

    useEffect(() => {
        return () => {
            dispatch(clearOrder())
        }
    }, [])

    const [orderVisible, toggleOrderVisible] = useToggle()
    const [variantsModal, toggleVariantsModal] = useToggle()

    const { order } = useSelector(state => state.order)

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems },
        { list: saleItems },
        { Paginate }
    ] = useListData('pointOfSaleItems', {
        category: category?.label,
        string,
    }, { notify: true }, 'items')

    const [,{ list: tables }] = useListData('tables', {}, { notify: true }, 'tables', 1000)

    const [, getCats] = usePet('saleItemCategories', {}, { notify: true, callback: ({ data }) => setCategories(data) })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            fetchItems()
    }

    const selectItem = itm => {
        setItem(itm)
        toggleVariantsModal()
    }

    const selectCategory = cat => {
        setCategory(cat)
        fetchItems()
    }

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => history.push('/app/bills'), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            onClose={close}
            visible={visible}
            drawerStyle={{ backgroundColor: '#f2f2f2' }}
            footer={
                <div className="w-full text-right">
                    {
                        order?.length > 0 ?
                            <Badge count={ order?.length }>
                                <button onClick={ toggleOrderVisible } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Complete</button>
                            </Badge>
                        : null
                    }
                    <button onClick={close} className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="100%">
            <p className="font-extrabold text-3xl mb-0">New Bill</p>
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                <div className="flex justify-center items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-name"
                        type="text"
                        placeholder="Type to search items" />
                </div>
                {
                    item &&
                    <Variants
                        item={item}
                        visible={variantsModal}
                        toggle={toggleVariantsModal} />
                }
                {/* {
                    item &&
                    <OrderVariants
                        item={item}
                        visible={variantsModal}
                        toggle={toggleVariantsModal} />
                } */}
                <Order
                    tables={ tables }
                    visible={orderVisible}
                    onPerform={ onComplete }
                    toggle={toggleOrderVisible} />
                <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                        <h2 className="font-semibold text-gray-800">Items in stock</h2>
                        <Select
                            isClearable
                            value={category}
                            onChange={selectCategory}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={categories.map(cat => ({ label: cat, value: cat }))}
                            placeholder="Select Category" />
                    </header>
                    <Receive
                        loading={itemsLoading}
                        error={itemsError}>
                        <div className="grid grid-cols-2 pb-7 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 mt-4 gap-x-4 gap-y-4 p-3 shadow-md">
                            {
                                saleItems.map((item, key) =>
                                    <SaleItem
                                        i={key}
                                        item={ item }
                                        selectItem={selectItem}
                                        order={order} />)
                            }
                        </div>
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </Drawer>
    )
}

export default NewBill